// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copied from v4 demo */
@font-face {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(https://fonts.gstatic.com/s/sourcesanspro/v21/6xK3dSBYKcSV-LCoeQqfX1RYOo3qOK7l.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@media screen and (min-width: 480px) {
  html {
    font-size: 18px;
  }
}
@media screen and (min-width: 992px) {
  html {
    font-size: 19px;
  }
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  min-height: 100dvh;
}

section#top {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 300;
  line-height: 1.4286;
  height: 3.7rem;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  border-bottom: 1px solid #F8F7F7;
}

section#top > :first-child {
  align-items: center;
  gap: 1rem;
}

#separator {
  width: 1px;
  height: 1.5rem;
  background: #DAD9D8;
}

.col {
  display: flex;
  flex-wrap: nowrap;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.logo {
  height: 1.69rem;
  display: block;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin: 4px;
  max-width: 250px;
  border-radius: 4px;
  color: inherit;
  background: transparent;
  text-decoration: none;
  font-family: inherit;
  font-size: inherit;
  border-radius: 0.6rem;
  white-space: nowrap;
}

.btn.btn-main {
  color: #ffffff;
  background: #282724;
}

section#viewer {
  height: calc(100dvh - 3.7rem);
  position: relative;
}

#viewer-container pdftools-viewer {
  font-family: unset;
  font-weight: unset;
}
#viewer-container {
  height: 100%;
}

#viewer-version {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 110%;
}`, "",{"version":3,"sources":["webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,wBAAA;AACA;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8GAAA;EACA,yKAAA;AACF;AAGA;EACE;IACE,eAAA;EADF;AACF;AAIA;EACE;IACE,eAAA;EAFF;AACF;AAKA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,0CAAA;EAEA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gCAAA;AAJF;;AAOA;EACE,mBAAA;EACA,SAAA;AAJF;;AAOA;EACE,UAAA;EACA,cAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,iBAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;AAJF;;AAOA;EACE,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,mBAAA;AAJF;;AAOA;EACE,6BAAA;EACA,kBAAA;AAJF;;AAQE;EACE,kBAAA;EACA,kBAAA;AALJ;AAEA;EAME,YAAA;AALF;;AAQA;EACE,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AALF","sourcesContent":["/* Copied from v4 demo */\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(https://fonts.gstatic.com/s/sourcesanspro/v21/6xK3dSBYKcSV-LCoeQqfX1RYOo3qOK7l.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC,\n    U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n@media screen and (min-width: 480px) {\n  html {\n    font-size: 18px;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  html {\n    font-size: 19px;\n  }\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  min-height: 100dvh;\n}\n\nsection#top {\n  font-family: 'Source Sans Pro',\n    sans-serif;\n  font-weight: 300;\n  line-height: 1.4286;\n  height: 3.7rem;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1rem;\n  border-bottom: 1px solid #F8F7F7;\n}\n\nsection#top > :first-child {\n  align-items: center;\n  gap: 1rem;\n}\n\n#separator {\n  width: 1px;\n  height: 1.5rem;\n  background: #DAD9D8;\n}\n\n.col {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.center {\n  text-align: center;\n}\n\n.right {\n  text-align: right;\n}\n\n.logo {\n  height: 1.69rem;\n  display: block;\n}\n\n.btn {\n  display: inline-block;\n  padding: 6px 12px;\n  margin: 4px;\n  max-width: 250px;\n  border-radius: 4px;\n  color: inherit;\n  background: transparent;\n  text-decoration: none;\n  font-family: inherit;\n  font-size: inherit;\n  border-radius: 0.6rem;\n  white-space: nowrap;\n}\n\n.btn.btn-main {\n  color: #ffffff;\n  background: #282724;\n}\n\nsection#viewer {\n  height: calc(100dvh - 3.7rem);\n  position: relative;\n}\n\n#viewer-container {\n  pdftools-viewer {\n    font-family: unset;\n    font-weight: unset;\n  }\n\n  height: 100%;\n}\n\n#viewer-version {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 110%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
